import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphTargetAudiencesHighlighted as Type } from '../custom';

export interface ParagraphTargetAudiencesHighlightedProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

// eslint-disable-next-line max-len
const ParagraphTargetAudiencesHighlighted: React.FC<ParagraphTargetAudiencesHighlightedProps> = (props) => {
  const { entity, className } = props;

  const classNames = c('ParagraphTargetAudiencesHighlighted', className);
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const targetAudiences = paragraph.field_target_audiences;

  return (
    <div id={uuid} className={classNames}>
      <Container>
        <div className="row u-gap--row--6">
          {targetAudiences.map((targetAudience) => {
            const id = targetAudience.target_id;
            const language = targetAudience.entity.langcode[0].value;

            return (
              <div className="col-12 col-md-6" key={`taxonomy:${id}:${language}`}>
                <Taxonomy
                  entity={Immutable.fromJS(targetAudience.entity)}
                  viewMode="teaser"
                  aboveTheFold
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTargetAudiencesHighlighted;
